import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import DbProductStage from "./../components/DbProductStage";
export function init(Survey) {
  var dBProductWidget = {
    //the widget name. It should be unique and written in lowcase.
    name: "dbproduct",
    //the widget title. It is how it will appear on the toolbox of the SurveyJS Editor/Builder
    title: "dB Produkt",
    //the name of the icon on the toolbox. We will leave it empty to use the standard one
    iconName: "",
    //If the widgets depends on third-party library(s) then here you may check if this library(s) is loaded
    widgetIsLoaded: function () {
      //return typeof $ == "function" && !!$.fn.select2; //return true if jQuery and select2 widget are loaded on the page
      return true; //we do not require anything so we just return true.
    },
    //SurveyJS library calls this function for every question to check, if it should use this widget instead of default rendering/behavior
    isFit: function (question) {
      //we return true if the type of question is textwithbutton
      return question.getType() === "dbproduct";
      //the following code will activate the widget for a text question with inputType equals to date
      //return question.getType() === 'text' && question.inputType === "date";
    },
    //Use this function to create a new class or add new properties or remove unneeded properties from your widget
    //activatedBy tells how your widget has been activated by: property, type or customType
    //property - it means that it will activated if a property of the existing question type is set to particular value, for example inputType = "date"
    //type - you are changing the behaviour of entire question type. For example render radiogroup question differently, have a fancy radio buttons
    //customType - you are creating a new type, like in our example "textwithbutton"
    activatedByChanged: function (activatedBy) {
      activatedBy;
      //we do not need to check acticatedBy parameter, since we will use our widget for customType only
      //We are creating a new class and derived it from text question type. It means that text model (properties and fuctions) will be available to us
      Survey.JsonObject.metaData.addClass("dbproduct", [], null, "radiogroup");

      //signaturepad is derived from "empty" class - basic question class
      //Survey.JsonObject.metaData.addClass("signaturepad", [], null, "empty");

      //Add new property(s)
      //For more information go to https://surveyjs.io/Examples/Builder/?id=addproperties#content-docs
      Survey.JsonObject.metaData.addProperties("dbproduct", [
        { name: "buttonText", default: "Click Me" },
      ]);

      Survey.Serializer.addProperty("question", {
        name: "productGroups:text",
        category: "general",
        default: '[{"name": "TestGroup"},{"name": "TestGroup2"}]',
      });
    },
    //If you want to use the default question rendering then set this property to true. We do not need any default rendering, we will use our our htmlTemplate
    isDefaultRender: true,
    //You should use it if your set the isDefaultRender to false
    //htmlTemplate: '<div id="db-products"></div><input type="text" name="daemstoffe" value="hahaha">',
    //The main function, rendering and two-way binding
    afterRender: function (question, el) {
      let mainDiv = document.createElement("div");
      mainDiv.id = "db-products";

      el.parentElement.insertBefore(mainDiv, el);
      el.style.display = "none";
      let products = [];

      question.choices.forEach(function (item) {
        products.push(item.value);
      });

      products = [
        {
          id: "242413",
          name: "Isover Kontur KP 1-035 Kerndämmplatte 40 mm",
          price: 21.64,
          image:
            "https://www.deinebaustoffe.de/media/catalog/product/cache/1/image/390x390/9df78eab33525d08d6e5fb8d27136e95/I/s/Isover_Kontur_KP_1_035_Kerndaemmplatte_40_mm_2.jpg",
          vp: "9.375",
          vp_unit: " m²",
          attributes: [
            "Maße: 1250x625x40 mm",
            "Wärmeleitgruppe: 035",
            "Klasse: A1 nicht brennbar",
            "Paket: 9,375 m²",
          ],
        },
        {
          id: "241240",
          name: "Rockwool Trennwandplatte Sonorock 40 mm",
          price: 13.45,
          image:
            "https://www.deinebaustoffe.de/media/catalog/product/cache/1/image/390x390/9df78eab33525d08d6e5fb8d27136e95/R/o/Rockwool_Trennwandplatte_Sonorock_40mm_2.jpg",
          vp: "7.5",
          vp_unit: " m²",
          attributes: [
            "Maße: 40x1000x625 mm",
            "Wärmeleitgruppe: 040",
            "diffusionsoffen / wärme- und schalldämmend",
            "Schmelzpunkt > 1000 °C",
          ],
        },
      ];

      new Vue({
        render: (h) => h(DbProductStage),
        data: {
          products: products,
          question: question,
          productGroups: question.productGroups,
        },
        // store: store
      }).$mount("#db-products");
    },
  };

  Survey.CustomWidgetCollection.Instance.add(dBProductWidget);
}
